import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Calendar from './components/Calendar';
import Login from './components/auth/Login';
import AdminSettings from './components/admin/AdminSettings';
import RequestShifts from './components/RequestShifts';
import TradeShifts from './components/TradeShifts';
import Navbar from './components/Navbar';
import { UserProvider } from './context/UserContext';
import { ShiftProvider } from './context/ShiftContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminRoute from './components/auth/AdminRoute';
export function App() {
  return <UserProvider data-id="element-0">
      <ShiftProvider data-id="element-1">
        <Router data-id="element-2">
          <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-3">
            <Navbar data-id="element-4" />
            <div className="flex-grow container mx-auto px-4 py-6" data-id="element-5">
              <Routes data-id="element-6">
                <Route path="/login" element={<Login data-id="element-8" />} data-id="element-7" />
                <Route path="/" element={<ProtectedRoute data-id="element-10">
                      <Dashboard data-id="element-11" />
                    </ProtectedRoute>} data-id="element-9" />
                <Route path="/calendar" element={<ProtectedRoute data-id="element-13">
                      <Calendar data-id="element-14" />
                    </ProtectedRoute>} data-id="element-12" />
                <Route path="/request-shifts" element={<ProtectedRoute data-id="element-16">
                      <RequestShifts data-id="element-17" />
                    </ProtectedRoute>} data-id="element-15" />
                <Route path="/trade-shifts" element={<ProtectedRoute data-id="element-19">
                      <TradeShifts data-id="element-20" />
                    </ProtectedRoute>} data-id="element-18" />
                <Route path="/admin/*" element={<AdminRoute data-id="element-22">
                      <AdminSettings data-id="element-23" />
                    </AdminRoute>} data-id="element-21" />
                <Route path="*" element={<Navigate to="/" replace data-id="element-25" />} data-id="element-24" />
              </Routes>
            </div>
          </div>
        </Router>
      </ShiftProvider>
    </UserProvider>;
}